import { fetchWrapper } from '../helpers';

export const locationService = {
  getById,
  create,
  getCatalogForm
};

const baseUrl = `${process.env.BASE_URL}/api/vendor/location`;
const baseUrlAPI = `${process.env.API_BASE_URL}/form/location`;

function getById(id) {
  return fetchWrapper.get(`${baseUrl}?id=${id}`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

// API
function getCatalogForm() {
	return fetchWrapper.get(baseUrlAPI);
}